import React, { useEffect, useState } from 'react';
import '../css/the-bar.css'

function TheBar({nowMonth, nowYear, currentDay, currentYear, currentMonth, selectedMonth}) {

  function daysInMonth (month, year) {
    return new Date(year, month, 0).getDate();
}

// console.log(currentDay)
// function checkCurrentDay(currentDay) {
  if (currentDay === 1) {
    currentDay = 1
  } else if (currentDay === 31) {
    currentDay = 31
  } else {
    currentDay = currentDay - 1
  }
// }

// useEffect(() => {
//   checkCurrentDay(+currentDay)
//   }, [currentDay]);

useEffect(() => {
  daysInMonth(currentMonth, currentYear)
  }, [selectedMonth]);

// console.log('in the bar: ', 'nowmonth ', nowMonth, 'nowyear ', nowYear, 'currentDay ', currentDay, 'currentYear ', currentYear, 'currentMonth ', currentMonth)
const [dayNamesForTheMonth, setdayNamesForTheMonth] = useState([]);

function getDayNames(currentYear, currentMonth) {

  let IndayNamesForTheMonth = [];

    for (let day = 1; day <= 31; day++) {
      const date = new Date(currentYear, (currentMonth - 1), day);
      const options = { weekday: "short" };
      const dayName = new Intl.DateTimeFormat("en-US", options).format(date);
      IndayNamesForTheMonth.push(dayName)
    }
  setdayNamesForTheMonth(IndayNamesForTheMonth)
}


useEffect(() => {
  getDayNames(currentYear, currentMonth)
  }, [selectedMonth, currentYear]);

  function handleMouseEnter(e) {
    let number = e.currentTarget.classList[0]

    let numberDisplay = document.getElementsByClassName(`day-number-${number}`)

    numberDisplay[0].style.display = "none";
 
    let nameDisplay = document.getElementsByClassName(`day-name-${number}`)
    nameDisplay[0].style.visibility = "visible";
  }
  
  function handleMouseLeave(e) {
    let number = e.currentTarget.classList[0]

    let nameDisplay = document.getElementsByClassName(`day-name-${number}`)
    nameDisplay[0].style.visibility = "hidden";

    let numberDisplay = document.getElementsByClassName(`day-number-${number}`)
    numberDisplay[0].style.display = "block";
  }

  return (
    <>
      <div id="the-bar">

      {
        [...Array(daysInMonth(currentMonth, currentYear))].map((_, i) =>

           (+currentYear === +nowYear && +currentMonth === +nowMonth && currentDay === i) ?
           <div className="day-block" key={i + "dayblock"}>
            <div 
            onMouseEnter={(e) => handleMouseEnter(e)} 
            onMouseLeave={(e) => handleMouseLeave(e)}
            className={`${i + 1} day-number-${i + 1} today`} id={`day-number-${i + 1}`} key={i}>
            
            {i + 1}
            </div>
            <div
            onMouseEnter={(e) => handleMouseEnter(e)} 
            onMouseLeave={(e) => handleMouseLeave(e)}
            className={`${i + 1} nameDay day-name-${i + 1} today`}>{dayNamesForTheMonth[i]}</div>
            </div>
           : 
           <div className="day-block" key={i + "dayblock2"}>
          <div 
            onMouseEnter={(e) => handleMouseEnter(e)} 
            onMouseLeave={(e) => handleMouseLeave(e)}
          className={`${i + 1} day-number-${i + 1}`} id={`day-number-${i + 1}`} key={i}>
          
            {i + 1}
            </div>
            <div 
            onMouseEnter={(e) => handleMouseEnter(e)} 
            onMouseLeave={(e) => handleMouseLeave(e)}
          className={`${i + 1} nameDay day-name-${i + 1}`}>{dayNamesForTheMonth[i]}</div>
          </div>
        )
          }
          

      </div>
    </>
  )
}

export default TheBar;
